"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegExpUtils = void 0;
/**
 * The `RegExpUtils` provides utility functions related to RegExp
 */
class RegExpUtils {
    /**
     * Safely escapes a string to be used as `pattern` string for RegExp constructor
     */
    static escapeRegExp(unsafeString) {
        return unsafeString.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
    }
}
exports.RegExpUtils = RegExpUtils;
//# sourceMappingURL=RegExpUtils.js.map